import { DateTime } from "luxon";
import { useCallback, useEffect, useRef, useState } from "react";

export const useMinuteTick = () => {
    const timeoutId = useRef(0);
    const [currentTime, SetCurrentTime] = useState<number>(DateTime.now().valueOf());

    const minuteTick = useCallback(() => {
        const now = DateTime.now();
        SetCurrentTime(now.valueOf());

        // seconds to the next minute (e.g. in 20 seconds if time now is 03:15:40)
        const newId = window.setTimeout(() => minuteTick(), (60 - now.second) * 1000);

        window.clearTimeout(timeoutId.current);
        timeoutId.current = newId;
    }, []);

    useEffect(() => {
        minuteTick();
        return () => window.clearTimeout(timeoutId.current);
        // behavior never changes
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return currentTime;
};
